"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var requireCoursesFromMap_1 = require("../utils/requireCoursesFromMap");
var combineVerifications_1 = require("../utils/combineVerifications");
var chapter130Courses = require("../tea_data/chapter130");
var mustPassOneOfValidations_1 = require("../utils/mustPassOneOfValidations");
var courseOptionsFromCourseMap_1 = require("../utils/courseOptionsFromCourseMap");
var bAndIfromChapter130 = __assign({}, chapter130Courses.A, chapter130Courses.B, chapter130Courses.C, chapter130Courses.D, chapter130Courses.F, chapter130Courses.I, chapter130Courses.K, chapter130Courses.M, chapter130Courses.N, chapter130Courses.P, chapter130Courses.oneTwentySevenB);
exports.default = function (allCourses, courseMap) {
    var cteOptions = courseOptionsFromCourseMap_1.default(courseMap, bAndIfromChapter130, 4, "cte-options");
    var validations = {
        agriculture: {
            options: cteOptions,
            validate: validateCTE(allCourses, "agriculture", chapter130Courses.A)
        },
        architectureConstruction: {
            options: cteOptions,
            validate: validateCTE(allCourses, "architecture-construction", chapter130Courses.B)
        },
        artsTechCom: {
            options: cteOptions,
            validate: validateCTE(allCourses, "Arts-Audio/Video-Communications", chapter130Courses.C)
        },
        businessManagementAndAdministration: {
            options: cteOptions,
            validate: validateCTE(allCourses, "business-management-and-administration", chapter130Courses.D)
        },
        finance: {
            options: cteOptions,
            validate: validateCTE(allCourses, "finance", chapter130Courses.F)
        },
        hospitalityAndTourism: {
            options: cteOptions,
            validate: validateCTE(allCourses, "hospitality-and-tourism", chapter130Courses.I)
        },
        informationTechnology: {
            options: cteOptions,
            validate: validateCTE(allCourses, "information-technology", chapter130Courses.K)
        },
        manufacturing: {
            options: cteOptions,
            validate: validateCTE(allCourses, "manufacturing", chapter130Courses.M)
        },
        marketing: {
            options: cteOptions,
            validate: validateCTE(allCourses, "marketing", chapter130Courses.N)
        },
        transportationDistributionAndLogistics: {
            options: cteOptions,
            validate: validateCTE(allCourses, "transportation-distribution-and-logistics", chapter130Courses.P)
        },
        english: {
            options: courseOptionsFromCourseMap_1.default(courseMap, englishElectives, 4, "english-options"),
            validate: function (courses) {
                if (courses === void 0) { courses = allCourses; }
                var level1CourseMap = Object.keys(englishElectives)
                    .filter(function (key) { return key.match(/ i$/); })
                    .reduce(function (map, key) { return englishElectives[key]; }, {});
                var level2CourseMap = Object.keys(englishElectives)
                    .filter(function (key) { return key.match(/ ii$/); })
                    .reduce(function (map, key) { return englishElectives[key]; }, {});
                var level3CourseMap = Object.keys(englishElectives)
                    .filter(function (key) { return key.match(/ iii$/); })
                    .reduce(function (map, key) { return englishElectives[key]; }, {});
                var has4Credits = requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, englishElectives, "4-english-credits-for-business", 4)();
                var hasLevel1 = requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, level1CourseMap, "1-level-1-english-elective", 1)();
                var hasLevel2 = requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, level2CourseMap, "1-level-2-english-elective", 1)();
                var hasLevel3 = requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, level1CourseMap, "1-level-3-english-elective", 1)();
                return combineVerifications_1.default([has4Credits, hasLevel1, hasLevel2, hasLevel3], has4Credits.coursesNotConsumed, 4, "bi-english-electives");
            }
        },
        technologyApplications: {
            options: courseOptionsFromCourseMap_1.default(courseMap, englishElectives, 4, "technology-applications-options"),
            validate: requireCoursesFromMap_1.requireSomeCoursesFromMap(allCourses, technologyApplicationsCoureMap, "technology-applications", 4)
        }
    };
    return validations;
};
var englishElectives = {
    "adv broadcast journalism i": 1,
    "adv broadcast journalism ii": 1,
    "adv broadcast journalism iii": 1,
    "adv journalism: lit mag ii": 1,
    "adv journalism: lit mag iii": 1,
    "adv journalism: lit magazine i": 1,
    "adv journalism: newspaper i": 1,
    "adv journalism: newspaper ii": 1,
    "adv journalism: newspaper iii": 1,
    "adv journalism: yearbook i": 1,
    "adv journalism: yearbook ii": 1,
    "adv journalism: yearbook iii": 1,
    "debate i": 1,
    "debate ii": 1,
    "debate iii": 1,
    "public speaking i": 1,
    "public speaking ii": 1,
    "public speaking iii": 1,
    /* new courses added 2018-06-26 */
    "indep study/journalism": 1,
    "indep study/speech": 1
};
var technologyApplicationsCoureMap = {
    "digital design & media prductn": 1,
    "3-d modeling and animation": 1,
    "digital art and animation": 1,
    "digital comm in the 21st cent": 1,
    "digital video and audio design": 1,
    "web communications": 0.5,
    "web design": 1,
    "web game development": 1,
    /* new courses added 2018-06-26 */
    "art iv-digital art & media iii": 1,
    "basics of student project mgt": 1,
    "ib design technology std level": 2,
    "ib envirn sys & soc stnd levl": 2,
    "ind stdy in evlv/emrg tchs 1st": 1,
    "ind study in tech app 3rd time": 1,
    "ind study in tech aps 1st time": 1,
    "ind study in tech aps 2nd time": 1,
};
var validateCTE = function (allCourses, title, capStoneMap) { return function (courses) {
    if (courses === void 0) { courses = allCourses; }
    var hasFourCreditsFromCourses = requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, bAndIfromChapter130, "4-same-credits-from-chapter130", 4)();
    var has2FromTheSameClusterValidations = Object.keys(chapter130Courses)
        .map(function (key) { return chapter130Courses[key]; })
        .map(function (req) {
        return requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, req, "requires-two-from-the-same-chapter", 2);
    });
    var has2FromTheSameCluster = mustPassOneOfValidations_1.mustPassOneOf.apply(void 0, [courses].concat(has2FromTheSameClusterValidations))();
    var hasOneFromCluster = requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, capStoneMap, "requires-one-from-" + title, 1)();
    return combineVerifications_1.default([hasFourCreditsFromCourses, has2FromTheSameCluster, hasOneFromCluster], hasFourCreditsFromCourses.coursesNotConsumed, 4, title + "-requirements");
}; };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/business-industry/index.js
// module id = 441
// module chunks = 22